import React from "react";
import "./GrantAccessRequest.less";
import TextFieldWithToolTip from "../../common/TextFieldWithToolTip/TextFieldWithToolTip";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import { ShowToast, toastType } from "../../../utils/toast-service";
import {
  Button,
  Dialog,
  AppBar,
  DialogActions,
  Toolbar,
  Typography
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import commonLabels from "../../../constants/messageConstants";
import { validateInput } from "../../../utils/validations";

export default class SearchRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textRequestedId: null,
      textEmailAddress: null,
      visitorName: null,
      visitor: [],
      biometricMessage: null,
      isBiometric: false,
      isBiometricAlreadySigned: false
    };
  }

  /** clear values */
  handleClear = () => {
    this.setState({
      textRequestedId: null,
      textEmailAddress: null,
      visitorName: null
    });
    const { setRequestDetails } = this.props;
    setRequestDetails(null, []);
  };

  /** call on handle change */
  handleChange = e => {
    if (e.target.value) {
      const { visitor } = this.state;
      const selectedRequest = visitor.find(x=> x.RequestCode === e.target.value);
      const params = {
        requestId: selectedRequest.RequestId,
      };
      const { handleLoader } = this.props;
      handleLoader(false);
      this.getSearchDetails(params);
    }
  };

  /** call on handle search */
  handleSearch = () => {
    const { textRequestedId, textEmailAddress } = this.state;

    if (
      (textRequestedId?.toString()?.trim() == null ||
        textRequestedId?.toString()?.trim() == "") &&
      (textEmailAddress?.toString()?.trim() == null ||
        textEmailAddress?.toString()?.trim() == "")
    ) {
      ShowToast(
        commonLabels.searchSectionMessage.message,
        toastType.ERROR,
        5000,
        200
      );
    } else {
      const { textRequestedId, textEmailAddress } = this.state;
      const params = {
        requestId: textRequestedId,
        requestedForEmail: textEmailAddress?.toString()?.trim()
      };

      const requestValidation = [
        {
          valueKey: "requestCode",
          type: "number",
          isRequired: false,
          fieldsName: "Request #"
        },
        {
          valueKey: "requestedForEmail",
          type: "email",
          isRequired: false,
          fieldsName: "Requested For Email"
        }
      ];

      const { handleLoader } = this.props;
      if (validateInput(params, requestValidation)) {
        handleLoader(true);
        this.getSearchDetails(params);
      }
    }
  };

  /** search details depends upon passed params */
  getSearchDetails = params => {
    const { setRequestDetails, handleLoader } = this.props;
    apiRequest({
      url: API_URL.request.GetRequestSearchDetails,
      params: params
    }).then(({ data }) => {
      if (data) {
        if (data?.brrDetails.length == 1) {
          this.setState({
            visitorName: data.brrDetails[0].RequestCode + " - " + data.brrDetails[0].RequestedFor,
            biometricMessage: commonLabels.biometricMessage.message,
            isBiometric: data.biometricDetails.find(x=>  x.requireBiometrics === true) !== undefined,
            isBiometricAlreadySigned: data.biometricDetails.find(x=>  x.requireBiometrics === true && x.isBiometricDocumentAlreadySigned == false) == undefined
          }, () => {
              if ((params.requestId <=0 || params.requestId == "") && params.requestedForEmail?.length > 0) {
                  params.requestId = data.brrDetails[0].RequestId;
                  params.requestedForEmail = null;
                  this.getSearchDetails(params);
              }
          });
          setRequestDetails(data.brrDetails[0], data.biometricDetails.filter(x=> x.requireBiometrics === true) || []);
        } else if (data?.brrDetails.length > 1) {
          this.setState({ openDialog: true, visitor: data.brrDetails});
        } else {
          this.setState({
            visitorName: commonLabels.proofOfIdentityMessage.message,
            isBiometric: false,
            isBiometricAlreadySigned: false
          });
        }
      } else {
        ShowToast(commonLabels.somethingWrong.message, toastType.ERROR);
      }
      handleLoader(false);
    });
  };

  /** call on state change */
  changeState = (key, value) => {
    const { setRequestDetails } = this.props;

    setRequestDetails(null, []);
    if (key == "textRequestedId" && value?.length < 10) {
      this.setState({
        [key]: value,
        visitorName: ""
      });
    } else if (key !== "textRequestedId") {
      this.setState({
        [key]: value,
        visitorName: ""
      });
    }
  };

  /** handle filtered record */
  handleFilteredRecord = () => {
    this.setState({
      openDialog: false
    });
  };

  render() {
    const {
      textRequestedId,
      textEmailAddress,
      visitorName,
      visitor,
      openDialog,
      biometricMessage,
      isBiometric,
      isBiometricAlreadySigned
    } = this.state;
    return (
      <>
        <div className={"col-xs-12 abrf-request-container"}>        
          <div>
            <div className={"col-xs-12 "}>
              <div className={"row"}>
                <div className={"col-xs-6"}>
                  <TextFieldWithToolTip
                    boldLabel
                    addPrefix={"REQ-"}
                    type={"number"}
                    id={"request#"}
                    txtName={"request#"}
                    disabled={false}
                    setFocus
                    value={textRequestedId || ""}
                    keyValue={"textRequestedId"}
                    onChange={this.changeState}
                    isRequired={false}
                    labelHeading={"Please enter Request # provided if any"}
                    toolTip={""}
                  />
                </div>
                <div className={"col-xs-6"}>
                  <TextFieldWithToolTip
                    boldLabel
                    id={"emailAddress"}
                    txtName={"emailAddress"}
                    disabled={false}
                    value={textEmailAddress || ""}
                    keyValue={"textEmailAddress"}
                    onChange={this.changeState}
                    isRequired={false}
                    labelHeading={"Email Address"}
                    toolTip={""}
                  />
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-xs-12 end-xs req-btn"}>
                  <Button
                    onClick={() => this.handleSearch()}
                    variant={"contained"}
                  >
                    {"Search\r"}
                  </Button>
                  <Button
                    onClick={() => this.handleClear()}
                    variant={"contained"}
                  >
                    {"Clear\r"}
                  </Button>
                </div>
              </div>
            </div>
            {visitorName && (
              <div className={"col-xs-12 div-border visitor-margin"}>
                <h2>{visitorName}</h2>
                {isBiometric && !isBiometricAlreadySigned && <h2>{biometricMessage}</h2>}
              </div>
            )}
          </div>
          {openDialog && (
            <Dialog
              open={openDialog}
              aria-labelledby={"responsive-dialog-title"}
              maxWidth={"lg"}
            >
              <AppBar
                style={{ position: "relative", backgroundColor: "#064473" }}
              >
                <Toolbar>
                  <Typography
                    variant={"h6"}
                    style={{ marginLeft: "10px", flex: "1" }}
                  >
                    {"Select Your Request Code\r"}
                  </Typography>
                </Toolbar>
              </AppBar>

              <FormControl component={"fieldset"} className={"radio-btn-label"}>
                <table className={"abrf-request-list-table"}>
                  <thead>
                    <tr>
                      <td />
                      <td className={"table-border"}>{"Request Code"}</td>
                      <td className={"table-border"}>
                        {"Requested For Email"}
                      </td>
                      <td className={"table-border"}>{"Requested For"}</td>
                    </tr>
                  </thead>
                  <tbody>
                    {visitor.map(value => (
                      <tr>
                        <td>
                          <input
                            type={"radio"}
                            name={"selectRequest"}
                            value={value.RequestCode}
                            onChange={this.handleChange}
                          />
                        </td>
                        <td className={"table-border"}>
                          {value.RequestCode.toString()}
                        </td>
                        <td className={"table-border"}>
                          {value.RequestedForEmail}
                        </td>
                        <td className={"table-border"}>{value.RequestedFor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </FormControl>
              <DialogActions>
                <Button
                  className={"runReport-btn"}
                  variant={"contained"}
                  onClick={() => this.handleFilteredRecord(false, "")}
                >
                  {"OK\r"}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </div>
      </>
    );
  }
}
